<script lang="ts">
    import {onMount} from "svelte";
    import ImageView from "../common/Image/ImageView.svelte";

    export let src;
    export let hoverSrc = null;

    onMount(() => {
    });


</script>

<div class="header-logo-view" class:can-hover={hoverSrc != null}>
    <a href="/#/">
        <div class="logo-image">
            <ImageView src={src}/>
        </div>
        {#if hoverSrc != null}
            <div class="logo-image hover">
                <ImageView src={hoverSrc}/>
            </div>
        {/if}
    </a>

</div>
<style lang="scss">
    .header-logo-view {
        display: inline-block;
        position: relative;
        height: 100%;
        width: 100%;

        > a {
            height: 100%;
            width: 100%;

            .logo-image {
                height: 100%;
                width: 100%;

                > :global(.image-view) {

                    display: block;
                }


            }
        }

        &.can-hover {
            > a {
                .logo-image {
                    &.hover {
                        position: absolute;
                        top: 0;
                        left: 0;
                        opacity: 0;
                    }
                }
            }

            &:hover {
                > a {
                    .logo-image {
                        opacity: 0;

                        &.hover {
                            opacity: 1;
                        }
                    }

                }
            }

        }

    }
</style>